import { render, staticRenderFns } from "./ChallengeAndLeagueSelectorTestView.vue?vue&type=template&id=08f78a5f&"
import script from "./ChallengeAndLeagueSelectorTestView.vue?vue&type=script&lang=js&"
export * from "./ChallengeAndLeagueSelectorTestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports